import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function LegalPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#FAF8F5] font-sans">
      {/* Header */}
      <div className="w-full py-6 px-6 border-b" style={{ borderColor: '#EDE7DC', backgroundColor: 'white' }}>
        <div className="max-w-2xl mx-auto flex items-center justify-between">
          <Link to="/" className="cursor-pointer font-serif text-[#3A3530] text-xl italic tracking-widest hover:opacity-70 transition-opacity">
            sanctuary
          </Link>
          <Link to="/" className="cursor-pointer font-sans text-[#8FA68B] text-xs tracking-wider hover:opacity-70 transition-opacity flex items-center gap-1">
            <i className="ri-arrow-left-line text-sm" />
            トップへ戻る
          </Link>
        </div>
      </div>

      <main className="max-w-2xl mx-auto px-6 py-16">
        <p className="font-sans text-[#8FA68B] text-xs tracking-[0.4em] mb-4 uppercase">legal</p>
        <h1 className="font-serif text-3xl text-[#3A3530] mb-12">特定商取引法に基づく表記</h1>

        <div className="space-y-0" style={{ border: '1px solid #EDE7DC', borderRadius: '8px', overflow: 'hidden' }}>
          {[
            { label: '販売事業者名', value: 'sanctuary（サンクチュアリ）' },
            { label: '代表者名', value: '山田 美那子' },
            { label: '所在地', value: '埼玉県川口市（詳細住所はお申し込み後にご案内いたします）' },
            { label: '電話番号', value: 'お申し込みフォームよりお問い合わせください' },
            { label: 'メールアドレス', value: 'info@sanctuary-kawaguchi.com' },
            { label: 'サービス名', value: '考えすぎてしまう人のための、自分に戻る体験セッション' },
            { label: '料金', value: '¥3,300〜（税込）' },
            { label: '支払方法', value: '銀行振込・各種キャッシュレス決済（詳細はお申し込み後にご案内）' },
            { label: '支払時期', value: 'セッション前日までにお支払いください' },
            { label: 'サービス提供時期', value: 'お申し込み・ご入金確認後、日程調整の上、実施いたします' },
            { label: 'セッション方法', value: 'オンライン（Zoom等）または対面（埼玉県川口市内）' },
            { label: 'キャンセルポリシー', value: 'セッション3日前まで：全額返金\nセッション前日・当日：返金不可\n※ やむを得ない事情の場合はご相談ください' },
            { label: '返金について', value: 'キャンセルポリシーに基づき対応いたします。サービスの性質上、セッション実施後の返金はお受けできません' },
            { label: '免責事項', value: 'sanctuary は医療機関ではありません。提供するサービスは医療行為ではなく、医師による診断・治療の代替となるものではありません。精神疾患の治療が必要な方は、医療機関へのご相談をおすすめします' },
          ].map((row, i) => (
            <div
              key={i}
              className="flex flex-col sm:flex-row"
              style={{ borderBottom: i < 14 ? '1px solid #EDE7DC' : 'none' }}
            >
              <div
                className="sm:w-44 flex-shrink-0 px-5 py-4 font-sans text-xs tracking-wide text-[#6B6460]"
                style={{ backgroundColor: 'rgba(143,166,139,0.06)' }}
              >
                {row.label}
              </div>
              <div className="flex-1 px-5 py-4 font-sans text-sm text-[#3A3530] leading-relaxed whitespace-pre-line">
                {row.value}
              </div>
            </div>
          ))}
        </div>

        <p className="font-sans text-[#8B8480] text-xs mt-8 leading-relaxed">
          最終更新日：2026年3月23日
        </p>
      </main>

      {/* Footer */}
      <div className="py-8 text-center" style={{ backgroundColor: '#EDE7DC' }}>
        <p className="font-sans text-[#B0A89E] text-xs">© 2026 sanctuary. All rights reserved.</p>
      </div>
    </div>
  );
}
